module.exports = __webpack_public_path__ + "static/img/icon1.4ec7423f.png";